module.exports = __webpack_public_path__ + "img/tiger.1fdde6b4.svg";